import mailIcon from '@assets/icons/mail.svg'
import phoneIcon from '@assets/icons/phone-call.svg'
import { TopBar } from '@components'
import { StyledTitle, StyledPhoneNo, StyledEmail, StyledEmailLink, StyledEmailLinkText, StyledMailIcon, StyledSection, StyledTextGroup, StyledPhoneLink, StyledPhoneLinkText, StyledIconWrapper, StyledHeadingText, StyledDescriptionText, StyledHeading, StyledDescription, StyledPhoneIcon } from './style'
import { COLORS } from '@themes'

const DashboardUnavailableContainer = () => {
  return (
    <>
      <TopBar backgroundColor={COLORS.WHITE_1} borderBottom="1px solid var(--form-border, #DFE1EC)" />
      <StyledSection>
        <StyledTitle>
          <StyledHeading><StyledHeadingText>Service contract has expired</StyledHeadingText></StyledHeading>
          <StyledDescription><StyledDescriptionText>Access to this Dashboard has been suspended. To restore access, please contact the SPR team to renew your service contract.</StyledDescriptionText></StyledDescription>
        </StyledTitle>
        <StyledTextGroup>
          <StyledPhoneNo>
            <StyledIconWrapper>
              <StyledPhoneIcon src={phoneIcon} alt="" />
            </StyledIconWrapper>
            <StyledPhoneLink><StyledPhoneLinkText>Call 02-011-8111</StyledPhoneLinkText></StyledPhoneLink>
          </StyledPhoneNo>
          <StyledEmail>
            <StyledMailIcon src={mailIcon} alt="" />
            <StyledEmailLink><StyledEmailLinkText>Email: service@sprsolarroof.co.th</StyledEmailLinkText></StyledEmailLink>
          </StyledEmail>
        </StyledTextGroup>
      </StyledSection>
    </>
  )
}

export default DashboardUnavailableContainer
